<template>
    <div>
        <el-pagination
        @size-change="set_limit"
        @current-change="set_page"
        :page-sizes="[1,2,10, 20, 30, 40, 50, 100]"
        :current-page="page"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="data_obj.total">
        </el-pagination>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
    props:{
        data_obj:{
            type:Object
        },
        limit:{
            type:Number
        },
        page:{
            type:Number
        }
    },
    methods:{
        set_page(page){
            this.$emit('set_page',page)
        },
        set_limit(limit){
            this.$emit('set_limit',limit)
            this.set_page(1)
        }
    }
}
</script>
